import { toast } from "sonner";

// Mirrors PendingTestSkipReason on the backend (pending_test.py). Keyed as a
// closed Record so a new reason is a compile error here, not a silent
// fallback. Lives outside the component file so react-refresh stays happy.
export type PendingTestSkipReason = "missing_edit_test" | "failed";

export const PENDING_TEST_SKIPPED_COPY: Record<PendingTestSkipReason, string> =
  {
    missing_edit_test:
      "The Optro test wasn't created because you don't have the Set Up Test permission. Ask an administrator.",
    failed:
      "The Optro test couldn't be created. Use Create Test on this control to try again.",
  };

const isKnownReason = (reason: string): reason is PendingTestSkipReason =>
  reason === "missing_edit_test" || reason === "failed";

export const toastPendingTestSkipped = (reason: string) => {
  toast.warning(
    PENDING_TEST_SKIPPED_COPY[isKnownReason(reason) ? reason : "failed"],
    { duration: 10000 },
  );
};
